const InputKeys = Object.freeze([
    'verification_input_one',
    'verification_input_two',
    'verification_input_three',
    'verification_input_four',
]);

export default InputKeys;
